import { useCallback } from "react";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import type { MRT_TableOptions } from "material-react-table";
import { DeletedCampaignsTable } from "Components/Admin/Campaigns/DeletedCampaignListTable/DeletedCampaignListTable";
import { useRestoreCampaignMutation } from "Api/Mutations/Admin/useRestoreCampaignMutation";
import { toast } from "sonner";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

const RESOURCES = Resources.Admin.Campaigns.Messages;

type Props = {
  data: Array<AdminCampaignDto>;
  isLoading: boolean;
  isRefetching: boolean;
  rowCount?: number;
  tableProps?: Partial<MRT_TableOptions<AdminCampaignDto>>;
};

export const DeletedCampaignListTableWrapper = ({
  data,
  isLoading,
  isRefetching,
  rowCount,
  tableProps,
}: Props) => {
  const { t } = useResource();

  const { mutate: restoreCampaign } = useRestoreCampaignMutation({
    onSuccess: () => {
      toast.success(t(RESOURCES.RestoreSuccess));
    },
    onError: () => {
      toast.error(t(RESOURCES.RestoreError));
    },
  });

  const handleRestore = useCallback(
    (id: number) => {
      if (window.confirm(t(RESOURCES.RestoreConfirm))) {
        restoreCampaign(id);
      }
    },
    [t, restoreCampaign],
  );

  return (
    <DeletedCampaignsTable
      data={data}
      isLoading={isLoading}
      isRefetching={isRefetching}
      onRestore={handleRestore}
      rowCount={rowCount}
      tableProps={tableProps}
    />
  );
};
